// extracted by mini-css-extract-plugin
module.exports = {"sub-title":"ResetPassword_sub-title__CAa25","errorMessage":"ResetPassword_errorMessage__3CRCU","return-login":"ResetPassword_return-login__1NobB"};